module.exports = "/assets/data/0f7263354987d9d00feeebd7c17fec38-DE1.data.json";